import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-basesaniversario',
  templateUrl: './basesaniversario.component.html',
  styleUrls: ['./basesaniversario.component.scss']
})
export class BasesaniversarioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
